import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Lottie from 'react-lottie';
import styles from './SplashPage.module.css';

// Import assets
import animationData from '../../Images/FlowerAnimation.json';
import WhiteLogo from '../../Images/SplashLogoWhite.svg';
import BlueLogo from '../../Images/SplashLogoBlue.svg';
import BlueWoman from '../../Images/SplashWomanBlue.svg';
import WhiteWoman from '../../Images/SplashWomanWhite.svg';

export default function SplashPage({ appLanguage }) {
  const history = useHistory();
  const [lottieLoaded, setLottieLoaded] = useState(false);

  const defaultOptions = {
    loop: false,
    autoplay: false, // optionally set to false until loaded
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Intro';

    // If user has seen intro, after 6s go to home, otherwise onboarding
    if (localStorage.getItem("hasSeenIntro")) {
      setTimeout(() => history.replace("/home"), 6000);
    } else {
      setTimeout(() => history.push('/onboarding-language'), 6000);
    }
  }, [history]);

  // This Lottie event callback triggers when images are loaded
  const handleLottieLoaded = () => {
    setLottieLoaded(true);
  };

  return (
    <div className={styles.splashContainer}>
      <div className={styles.splashScreen} style={{ backgroundColor: '#FFFFFF' }}>
        {/* Show your images immediately */}
        <img src={BlueLogo} alt="Blue Logo" className={styles.logo} />
        <img src={WhiteWoman} alt="White Background Woman" className={styles.imageWhiteWoman} />

        {/* Conditionally render or fade in Lottie once loaded */}
        <div
          className={styles.flowerAnimation}
          style={{ 
            opacity: lottieLoaded ? 1 : 0, 
            transition: 'opacity 1s ease-in' 
          }}
        >
          <Lottie
            options={defaultOptions}
            eventListeners={[
              { eventName: 'DOMLoaded', callback: handleLottieLoaded }
            ]}
            height="100%"
            width="100%"
          />
        </div>
      </div>
    </div>
  );
}